import { isRenavam } from 'validation-br';

export const renavamValidation = (renavam: string): boolean => {
  return isRenavam(renavam);
};
